import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

const today = () => new Date().toISOString().split("T")[0];

function HrAssetAssignModal({ show, onClose, onSubmit, employees = [], isSubmitting, error }) {
  const [form, setForm] = useState({ employeeId: "", assignedDate: today(), conditionOnAssign: "", notes: "" });

  if (!show) return null;
  const set = (f, v) => setForm((p) => ({ ...p, [f]: v }));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 p-4">
      <button type="button" onClick={onClose} className="absolute inset-0" />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">Assign Asset</h3>
          <button type="button" onClick={onClose} className="rounded-lg p-2 text-gray-400 hover:bg-gray-100"><FaTimes /></button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(form); }} className="px-6 py-5 space-y-4">
          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
          <div>
            <label htmlFor="assign-employee" className="mb-1 block text-sm font-medium text-gray-700">Employee <span className="text-red-500">*</span></label>
            <select id="assign-employee" required value={form.employeeId} onChange={(e) => set("employeeId", e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#2470B7]">
              <option value="">— Select Employee —</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>{emp.fullName} {emp.employeeCode ? `(${emp.employeeCode})` : ""}</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="assign-date" className="mb-1 block text-sm font-medium text-gray-700">Assigned Date <span className="text-red-500">*</span></label>
            <input id="assign-date" type="date" required value={form.assignedDate} onChange={(e) => set("assignedDate", e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#2470B7]" />
          </div>
          <div>
            <label htmlFor="assign-condition" className="mb-1 block text-sm font-medium text-gray-700">Condition on Assign</label>
            <input id="assign-condition" value={form.conditionOnAssign} onChange={(e) => set("conditionOnAssign", e.target.value)}
              placeholder="e.g. Good, Minor scratches"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#2470B7]" />
          </div>
          <div>
            <label htmlFor="assign-notes" className="mb-1 block text-sm font-medium text-gray-700">Notes</label>
            <textarea id="assign-notes" rows={2} value={form.notes} onChange={(e) => set("notes", e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#2470B7] resize-none" />
          </div>
          <div className="flex justify-end gap-3 border-t border-gray-100 pt-4">
            <button type="button" onClick={onClose}
              className="rounded-lg border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">Cancel</button>
            <button type="submit" disabled={isSubmitting}
              className="rounded-lg bg-[#2470B7] border border-[#2470B7] px-5 py-2 text-sm font-semibold text-white hover:bg-[#1f5f9b] disabled:opacity-60">
              {isSubmitting ? "Assigning…" : "Assign Asset"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default HrAssetAssignModal;
